import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide';

import { AddToCartButton } from '@sharedComponents/AddToCartButton';
import { Watchdog } from '@sharedComponents/Watchdog';
import { watchdogMessages } from '@sharedComponents/Watchdog/watchdogMessages';

import { getItemDataById_vpProductById } from '../queries/__generated__/getItemDataById';
import { ButtonWrapper, StyledButtonWatchdog } from '../styled';

interface IBuyButtonProps {
  buttonElementClassName: string;
  product: getItemDataById_vpProductById;
  showAddToCartModal: boolean;
  disableRedirect: boolean;
  onProductAdded: (product: getItemDataById_vpProductById) => void;
  onClosingCartModal?: () => void;
  trackAddToCartAsync: (
    product: getItemDataById_vpProductById
  ) => Promise<void>;
}

export const BuyButton: React.FC<IBuyButtonProps> = ({
  buttonElementClassName,
  product,
  showAddToCartModal,
  disableRedirect,
  onProductAdded,
  onClosingCartModal,
  trackAddToCartAsync,
}) => {
  const trackAddToCartCallback = React.useCallback(() => {
    if (trackAddToCartAsync) {
      return trackAddToCartAsync(product);
    }
  }, [trackAddToCartAsync, product]);

  return (
    <>
      {product.canBuy && (
        <AddToCartButton
          buttonElementClassName={buttonElementClassName}
          buttonWrapper={ButtonWrapper}
          buttonStyle={ButtonModel.Styles.secondary}
          buttonSize={ButtonModel.Sizes.xSmall}
          product={{
            ...product,
            variantName: product.annotation,
          }}
          count={1}
          showAddToCartModal={showAddToCartModal}
          wrapable={true}
          disableRedirect={disableRedirect}
          onProductAdded={() => onProductAdded(product)}
          trackAddToCartAsync={trackAddToCartCallback}
          closingModal={onClosingCartModal}
        />
      )}
      <Watchdog variant={product} id="productItemWatchdog">
        <StyledButtonWatchdog
          buttonStyle={ButtonModel.Styles.secondary}
          buttonSize={ButtonModel.Sizes.xSmall}
        >
          <FormattedMessage {...watchdogMessages.watchAvailability} />
        </StyledButtonWatchdog>
      </Watchdog>
    </>
  );
};
